import { inject, injectable } from 'inversify';
import OrdersRepository from 'src/features/orders/data/OrdersRepository';
import { CreateOrderParams } from 'src/features/orders/data/service/OrdersService.types';
import { PaymentMethodSlug } from 'src/types/common';
import { AxiosError } from 'axios';
import { getMercadoPagoPaymentErrorMessage } from 'src/utils/cards/getMercadoPagoErrorMessage';
import { UnknownError } from 'src/utils/errors/UnknownError';

export interface CreateMercadoPagoOrderUseCaseParams
  extends Omit<CreateOrderParams, 'payment_method'> {}

@injectable()
class CreateMercadopagoOrderUseCase {
  @inject(OrdersRepository) private ordersRepository!: OrdersRepository;

  async execute(params: CreateMercadoPagoOrderUseCaseParams) {
    try {
      return await this.ordersRepository.createOrder({
        ...params,
        payment_method: PaymentMethodSlug.Card,
      });
    } catch (error) {
      if (
        error instanceof AxiosError &&
        error.response &&
        error.response.data?.code
      ) {
        const mercadoPagoErrorCode = error.response.data.code;
        const errorMsg =
          getMercadoPagoPaymentErrorMessage(mercadoPagoErrorCode);

        throw new Error(errorMsg);
      }

      throw new UnknownError(error);
    }
  }
}

export default CreateMercadopagoOrderUseCase;
